import { Button, EmptyState } from '@react-gcc-eds/core';
import AuthKeycloak from 'api/AuthKeycloak';
import { FormattedMessage } from 'react-intl';

const LoginRequired = () => {
    return <EmptyState action={<Button onClick={() => AuthKeycloak('login-required')}><FormattedMessage id="APP.LOGIN_REQ" /></Button>} />
}

export default LoginRequired;